module.exports = __webpack_public_path__ + "assets/img/97e3e315c9cf5af891975775e1c21fd3.svg";